module.exports = __webpack_public_path__ + "static/img/EF_H5.d1a9b42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/EF_H5.png
// module id = JkqH
// module chunks = 34